/** RevenueCat entitlement that unlocks GearSync Pro. */
export const GEARSYNC_PRO_ENTITLEMENT = "GearSync Pro";

/** Current offering lookup key in the RevenueCat dashboard. */
export const GEARSYNC_DEFAULT_OFFERING = "default";

/** Store product identifier for the US$2.99/month Pro plan. */
export const GEARSYNC_MONTHLY_PRODUCT_ID = "gearsync_pro_monthly";
